import React, { Fragment } from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';

class SmokingFilter extends baseFilter {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,

            filters: {
                'Smoker': {
                    filter_name: 'smoker',
                    active: false,
                    count: null
                },

                'Ex-Smoker': {
                    filter_name: 'ex_smoker',
                    active: false,
                    count: null
                },

                'Non-Smoker': {
                    filter_name: 'non_smoker',
                    active: false,
                    count: null
                },

                'Never Smoked': {
                    filter_name: 'never_smoked',
                    active: false,
                    count: null
                },

                'Unknown': {
                    filter_name: 'unknown',
                    active: false,
                    count: null
                }
            },

            activeCount: 0
        };

        this.aggregates = {
            'sample.patient.smoking_status': 'count'
        };

        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.processResponse = this.processResponse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);
    }

    static getFiltersFromQS(qsObj, oldFilters = {}) {
        const activeSmokingFilters = ('smoking_status' in qsObj)
            ? _.split(qsObj.smoking_status, '_')
            : [];

        return _.reduce(
            oldFilters,
            (result, filterProps, smokingStatus) => {
                result[smokingStatus] = {
                    ...filterProps,

                    active:
                        activeSmokingFilters.indexOf(
                            urlify(smokingStatus)
                        ) >= 0
                };

                return result;
            },
            {}
        );
    }

    static getDerivedStateFromProps(newProps, oldState) {
        const currentQS = qs.parse(
            newProps.location.search,
            { ignoreQueryPrefix: true }
        );

        const newFilters = SmokingFilter.getFiltersFromQS(
            currentQS,
            oldState.filters
        );

        return {
            filters: newFilters,
            activeCount: _.filter(newFilters, 'active').length
        };
    }

    toggleCollapse() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    updateAPIURL(apiQS, newListProps) {
        const newQS = qs.parse(
            newListProps.location.search,
            { ignoreQueryPrefix: true }
        );

        const activeFilters = SmokingFilter.getFiltersFromQS(
            newQS,
            this.state.filters
        );

        const apiSmokingFilters = _.toPairs(activeFilters)
            .filter(([, filterProps]) => filterProps.active)
            .map(([, filterProps]) => filterProps.filter_name);

        if (apiSmokingFilters.length > 0) {
            const filterQS = {
                name: 'sample',
                op: 'has',
                val: {
                    name: 'patient',
                    op: 'has',
                    val: {
                        name: 'smoking_status',
                        op: 'in',
                        val: apiSmokingFilters
                    }
                }
            };

            apiQS.filter = _.get(apiQS, 'filter', [])
                .concat(filterQS);
        }

        return _.merge(apiQS, {
            agg: this.aggregates
        });
    }

    processResponse(response) {
        const respAgg = this.get_agg_values(response);
        const aggField = _.keys(this.aggregates)[0];

        if (!respAgg || !respAgg[aggField]) {
            return;
        }

        const counts = respAgg[aggField][this.aggregates[aggField]];

        if (!counts) {
            return;
        }

        const newFilters = {
            ...this.state.filters
        };

        _.forEach(counts, (count, smokingStatus) => {
            /*
             * API uses Never-Smoked but UI uses Never Smoked.
             */
            if (smokingStatus === 'Never-Smoked') {
                smokingStatus = 'Never Smoked';
            }

            /*
             * Ignore empty/null values.
             */
            if (
                smokingStatus === 'None' ||
                smokingStatus === 'null' ||
                smokingStatus === null
            ) {
                return;
            }

            if (newFilters[smokingStatus]) {
                newFilters[smokingStatus] = {
                    ...newFilters[smokingStatus],
                    count: count
                };
            }
        });

        this.setState({
            filters: newFilters
        });
    }

    toggleCheckbox(event) {
        const smokingStatus = event.target.name;
        const smokingValue = urlify(smokingStatus);

        const currentQS = qs.parse(
            window.location.search,
            { ignoreQueryPrefix: true }
        );

        let smokingFilter = ('smoking_status' in currentQS)
            ? _.split(currentQS.smoking_status, '_')
            : [];

        if (event.target.checked) {
            if (smokingFilter.indexOf(smokingValue) === -1) {
                smokingFilter.push(smokingValue);
            }
        } else {
            smokingFilter = smokingFilter.filter(
                item => item !== smokingValue
            );
        }

        currentQS.smoking_status =
            smokingFilter.length > 0
                ? _.join(smokingFilter.sort(), '_')
                : undefined;

        currentQS.page = undefined;

        this.props.history.push(
            window.location.pathname +
            qs.stringify(currentQS, { addQueryPrefix: true })
        );
    }

    renderSmokingCheckboxes() {
        const filters = this.state.filters || {};

        let active = [];
        let inactive = [];

        _.toPairs(filters).forEach(([status, details]) => {
            const checkbox = (
                <FormGroup check key={status}>
                    <Input
                        type="checkbox"
                        name={status}
                        onChange={this.toggleCheckbox}
                        checked={!!details.active}
                    />

                    {' '}

                    <Label
                        className="ml-4 mt-1"
                        check
                    >
                        {status}

                        {details.count !== null &&
                            details.count !== undefined && (
                                <span className="secondary">
                                    {' '}({details.count})
                                </span>
                            )}
                    </Label>
                </FormGroup>
            );

            if (details.active) {
                active.push(checkbox);
            } else {
                inactive.push(checkbox);
            }
        });

        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }

    componentDidMount() {
        this.props.registerResponse(this.processResponse);
        this.props.registerRequest(this.updateAPIURL);
    }

    componentWillUnmount() {
        this.props.unregisterResponse(this.processResponse);
        this.props.unregisterRequest(this.updateAPIURL);
    }

    render() {
        return (
            <Card className="mb-2 z0 hover">
                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >
                    <div className="d-inline w-50">
                        Smoking Status
                    </div>

                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />
                </CardHeader>

                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        {this.renderSmokingCheckboxes()}
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}

export default withRouter(SmokingFilter);